export enum GallectionSourceType {
  FEATURED_GALLERY = 'featured_gallery',
  NEWEST = 'newest',
  GALLERY = 'gallery',
  COLLECTION = 'collection',
  PRIVATE_COLLECTION = 'private_collection',
  ADOPTABLE_BOUGHT = 'adoptable_bought',
  ADOPTABLE_FOR_SALE = 'adoptable_for_sale',
  ORIGINALS_FOR_SALE = 'originals_for_sale',
}

export enum ExhibitionistWidgetType {
  TALL = 'tall',
  STRIP = 'strip',
  STRIP_SHORT = 'strip_short',
}
